import React from "react"
import { firestore } from "../core"
import { Navigate } from "react-router-dom"
import { useLive, useSpace, writeLiveVoiceEvent } from "popopo-lib-front/firestore-access"
import { SpaceLiveStopForm } from "../component/live/SpaceLiveStopForm"
import { useAccessContext } from "../component/guard/AccessGuard"
import { Button } from "react-bootstrap"
import { SelectionCreateForm } from "../component/selection/SelectionCreateForm"
import { SelectionList } from "../component/selection/SelectionList"
import { SpaceLiveCommentList } from "../component/live/SpaceLiveCommentList"
import { SpaceLiveCommentCreateForm } from "../component/live/SpaceLiveCommentCreateForm"
import { SpaceLiveUpdateForm } from "../component/live/SpaceLiveUpdateForm"
import { SpinnerRow } from "../component/SpinnerRow"
import { SpaceLiveAccessLogForm } from "../component/live/SpaceLiveAccessLogForm"
import { SpaceLivePowerSendForm } from "../component/live/SpaceLivePowerSendForm"
import { SpaceLivePowerRanking } from "../component/live/SpaceLivePowerRanking"
import { Paths } from "../paths"
import { usePathParams } from "popopo-lib-front/hook/path"
import { ShareImageDownloadButton } from "../component/ShareImageDownloadButton"

export const Live = () => {
  const context = useAccessContext()
  const { spaceKey, liveId } = usePathParams(Paths.spaces.space.lives.live)
  const space = useSpace(firestore, spaceKey)
  const live = useLive(firestore, spaceKey, liveId)

  if (space === "loading" || live === "loading") {
    return <SpinnerRow />
  }

  if (space === null) {
    return <Navigate to={Paths.top.path} />
  }

  if (live === null) {
    return (
      <div className="row">
        <div className="col-12 offset-lg-3 col-lg-6 d-flex flex-column align-items-center gap-3">
          <h3>Live Info</h3>
          <div>ライブが見つかりませんでした。</div>
        </div>
      </div>
    )
  }

  return (<>
    <div className="row gy-5">
      <div className="col-12 offset-lg-2 col-lg-8 d-flex flex-column align-items-center gap-3">
        <h3>Live</h3>
        <div>
          <div>ID: {live.id}</div>
          <div>Genre Id: {live.genre_id}</div>
          <div>Tags: {live.tags.join(", ")}</div>
          <div>Type: {live.status}</div>
          <div>Task ID: {live.task_id ?? "null"}</div>
          <div>Token: {live.token}</div>
          <div>Users: {live.users.join(", ")}</div>
          <div>Count: 現在 {live.latest_count.current}, 累計 {live.latest_count.overall}</div>
          <div>抽選通話当選者: {live.selected_talk_participant?.user?.id}</div>
          <div>Owner Last Connected At : {new Date(live.owner_last_connected_at).toLocaleString()}</div>
          <div>Created at: {new Date(live.created_at).toLocaleString()}</div>
          <div>Updated at: {new Date(live.updated_at).toLocaleString()}</div>
        </div>
        <ShareImageDownloadButton
          getIdToken={() => context.credential.user.getIdToken()}
          path={`/api/v2/spaces/${spaceKey}/lives/${liveId}/share-image`}
          filename={`live-${liveId}-share-image.png`}
          label="ライブ共有画像DL"
        />
      </div>

      <div className="col-6 d-flex flex-column align-items-center gap-3">
        <h3>Write Live Access Log</h3>
        <SpaceLiveAccessLogForm firebase={context.credential.user} spaceKey={space.id} liveId={live.id} />
      </div>

      <div className="col-6 d-flex flex-column align-items-center gap-3">
        <h3>Write Live Voice Event</h3>
        <Button
          variant="warning"
          onClick={async () => {
            const res = await writeLiveVoiceEvent(firestore, context.credential.user, live.space_key, live.id)
            console.info(res)
          }}
        >
          Write
        </Button>
      </div>

      <div className="col-6 d-flex flex-column align-items-center gap-3">
        <h3>Send Live Power</h3>
        <SpaceLivePowerSendForm firebase={context.credential.user} spaceKey={space.id} liveId={live.id} />
      </div>

      <div className="col-6 d-flex flex-column align-items-center gap-3">
        <div>パワー合計: {live.latest_count.power}</div>
        <h3>Power Ranking</h3>
        <SpaceLivePowerRanking spaceKey={space.id} liveId={live.id} />
      </div>

      <div className="col-12 col-lg-6 d-flex flex-column align-items-center gap-3">
        <h3>Update Live</h3>
        <SpaceLiveUpdateForm firebase={context.credential.user} live={live} />

        <h3>Stop Live</h3>
        <SpaceLiveStopForm firebase={context.credential.user} spaceKey={space.id} liveId={live.id} />

        <h3>Comments</h3>
        <SpaceLiveCommentList firebase={context.credential.user} spaceKey={space.id} liveId={live.id} />
        <SpaceLiveCommentCreateForm firebase={context.credential.user} spaceKey={space.id} liveId={live.id} />
      </div>

      <div className="col-12 col-lg-6 d-flex flex-column align-items-center gap-3">
        <h3>Selections</h3>
        <SelectionList firebase={context.credential.user} spaceKey={space.id} liveId={live.id} />

        <h3>Create Selection</h3>
        <SelectionCreateForm firebase={context.credential.user} spaceKey={space.id} liveId={live.id} />
      </div>
    </div>
  </>)
}
